'use client';

import type { ReactNode } from 'react';

import styles from './RepairDetailsReadOnlySection.module.scss';

interface RepairDetailsReadOnlySectionProps {
  title: string;
  children: ReactNode;
  testId?: string;
}

export function RepairDetailsReadOnlySection({
  title,
  children,
  testId,
}: Readonly<RepairDetailsReadOnlySectionProps>) {
  return (
    <section className={styles.section} data-testid={testId}>
      <h3 className={styles.title}>{title}</h3>
      <div className={styles.card}>
        <div className={styles.content}>{children}</div>
      </div>
    </section>
  );
}
